var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var players = [];
window.onYouTubeIframeAPIReady = function() {
    var i = 0;

    $(".yt-video-wrap, .vdo_wrap").each(function(index){
        var id = $(this).find("iframe").attr("id");
        players.push(new YT.Player(id, {
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        }));
    });
};
function onPlayerReady(event){
}
function onPlayerStateChange(event){
}

$(function(){
	var $videoArea = $(".videoPlayBox");

	if($videoArea.length > 0){
		$videoArea.each(function(index){
			var _this = $(this);
			_this.on("click", ".vdo_cover_img > a", function(e){
				e.preventDefault();

				$(this).parent().css("display", "none");
				$(this).closest(".videoPlayBox").find(".vdo_wrap").css("display", "block");

				players[index].playVideo();
			});
		});
	}
});

$(function(){
    var $videoArea = $(".yt-video-wrap");
    if($videoArea.length > 0){
        $videoArea.each(function(index){
            var _this = $(this).parents('.sul-video-wrap');
            _this.on("click", ".btn-play-video", function(e){
                e.preventDefault();

                _this.addClass('playing');

                players[index].playVideo();
            });
            $videoArea.each(function(index){
                var _this = $(this).parents('.video-wrap');
                _this.on("click", ".vdo_cover_img button", function(e){
                    e.preventDefault();
                    _this.addClass('playing');
                    players[index].playVideo();
                });
            });
        });
    }
});

// Video playing
$('.video-wrap').each(function(){
    var _this = $(this).parents('.sul-video-wrap');
    _this.on('click','.btn-play-video', function(e){
        _this.addClass('playing');
    })
});

// Accordion
$('.btn-accordion-wrap button').on('click',function (e){
    e.preventDefault();

    $(this).closest('.btn-accordion-wrap').toggleClass('active');
    //$('.accordion-cont-wrap .sul-slider').slick('setPosition');
});

// 상단 슬라이드
$('.prd-thumb-wrap .sul-slider').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.prd-thumb-wrap .sul-slide-btn-prev'),
    nextArrow: $('.prd-thumb-wrap .sul-slide-btn-next'),
    infinite:false,
    asNavFor: '.prd-thumb-wrap .sul-slide-img-nav'
});

$('.prd-thumb-wrap .sul-slide-img-nav').slick({
    slidesToShow: 3.552631578947368,
    slidesToScroll: 1,
    accessibility: false,
    asNavFor: '.prd-thumb-wrap .sul-slider',
    arrows: false,
    infinite:false,
    focusOnSelect:true,
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 3.6
        }
    }]
});

// 사용단계 & 사용방법
var isExistUseStepImg = $('.use-step-cont').find('.sul-slide-item img').length;
var useStepLength = $('.use-step-cont').find('.sul-slide-item').length;
var useStepSlidesShow = useStepLength > 1 ? 2 : 1;

if(!isExistUseStepImg){
    $('.use-step-cont').find('.sul-slide-wrap').addClass('img-none')
}

$('.use-step-cont').find('.sul-slider').slick({
    slidesToShow: useStepSlidesShow,
    slidesToScroll: useStepSlidesShow,
    accessibility: false,
    arrows: true,
    fade: false,
    dots: true,
    infinite : false,
    dotsClass: "sul-slide-nav",
    draggable : true,
    adaptiveHeight: true,
    prevArrow: $('.use-step-cont').find('.sul-slide-btn-prev'),
    nextArrow: $('.use-step-cont').find('.sul-slide-btn-next'),
    appendDots: $('.use-step-cont').find('.sul-slide-nav-wrap'),
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
});

// 함께 쓰면 좋은 제품
$('.together-cont').find('.sul-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    accessibility: false,
    arrows: true,
    fade: false,
    dots: true,
    infinite : false,
    dotsClass: "sul-slide-nav",
    draggable : true,
    prevArrow: $('.together-cont').find('.sul-slide-btn-prev'),
    nextArrow: $('.together-cont').find('.sul-slide-btn-next'),
    appendDots: $('.together-cont').find('.sul-slide-nav-wrap'),
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
});

// 진성 고객 리뷰
$('.real-review-cont').find('.sul-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    fade: false,
    dots: true,
    infinite : false,
    dotsClass: "sul-slide-nav",
    draggable : true,
    adaptiveHeight: true,
    prevArrow: $('.real-review-cont').find('.sul-slide-btn-prev'),
    nextArrow: $('.real-review-cont').find('.sul-slide-btn-next'),
    appendDots: $('.real-review-cont').find('.sul-slide-nav-wrap'),
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
});

// 효능 & 효과
$('.effect-cont').find('.sul-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    dots: true,
    infinite : false,
    dotsClass: "sul-slide-nav",
    draggable : true,
    adaptiveHeight: true,
    prevArrow: $('.effect-cont').find('.sul-slide-btn-prev'),
    nextArrow: $('.effect-cont').find('.sul-slide-btn-next'),
    appendDots: $('.effect-cont').find('.sul-slide-nav-wrap')
});

//용량에 따라 슬라이드 첫번째 이미지, 가격, 링크url 변경
var $btnMeasure = $('.measure-list').find('.btn-measure');

$btnMeasure.on("click", function(e) {
    e.preventDefault();
    $btnMeasure.removeClass("active").removeAttr("title");
    $(this).addClass("active").attr("title", "selected");

    var img = $(this).find("span").data("img");
    var imgAlt = $(this).find("span").data("img-alt"); 
    var price = $(this).find("span").data("price");
    var url = $(this).find("span").data("url");
    var selectedSize = $(this).find("span").text().trim();

    //이미지변경
    $(".prd-thumb-wrap .nav-item").eq(0).find("img").attr("src",img);
    $(".prd-thumb-wrap .sul-slide-item").eq(0).find("img").attr("src",img);
    $(".prd-thumb-wrap .nav-item").eq(0).find("img").attr("alt",imgAlt);
    $(".prd-thumb-wrap .sul-slide-item").eq(0).find("img").attr("alt",imgAlt);
    $('.prd-thumb-wrap .sul-slide-list').slick("slickGoTo", $(e.currentTarget).index(1));
    $('.prd-thumb-wrap .sul-slide-img-nav').slick("slickGoTo", $(e.currentTarget).index(1));

    const swiperCarousel = document.querySelector('swiper-carousel');

    if (swiperCarousel.carouselInstance) {
    swiperCarousel.carouselInstance.slideTo(0, 300); // 0번 슬라이드(첫 번째)로 300ms 속도로 이동
    }

    //가격
    // $('.prd-price-wrap .prd-price').find('span').text(price);
    $('.prd-price-wrap .prd-price').each(function () {
    const $strong = $(this);
    const $span = $strong.find('span');
    const spanHtml = $span.prop('outerHTML'); // <span>...</span> 그대로 유지
    $strong.html(spanHtml + price); // span 다음 텍스트만 교체
    });

    //url
    // $('.store-online').find('a').attr("href", url);

    $('li > a.color-chip').each(function() {
        // class에 on이 포함된 요소 찾기
        if ($(this).parent('li').hasClass('on')) {
            const activeColorName = $(this).data('color-name'); // on 클래스 있는 요소의 color-name

            // console.log(activeColorName);

            // 같은 color-name & size를 가진 요소들 찾아서 클릭 이벤트 발생
            $('li > a.color-chip').each(function() {
                if ($(this).data('color-name') === activeColorName && $(this).data('size') === selectedSize) {
                    $(this).trigger('click');
                    return false;
                }
            });
        }

        const $li = $(this).closest('li');
        const dataSize = $(this).data('size');

        if (dataSize !== selectedSize) {
            $li.hide();
        } else {
            $li.show();
        }
    });

});

$(document).ready(function() {
    // active 클래스가 붙은 버튼 클릭 이벤트 강제 발생
    $('.btn-measure.active').trigger('click');
});

// 컬러칩 추가
var $btnColorChip = $('.color-chip-wrap').find('.color-chip');

$btnColorChip.on("click", function(e) {
    e.preventDefault();
    var $this = $(this);
    var img1 = $this.data("img-item1");
    var img2 = $this.data("img-item2");
    var imgAlt1 = $this.data("alt-item1");
    var imgAlt2 = $this.data("alt-item2");
    var colorName = $this.data("color-name");

    $btnColorChip.parents('li').removeClass("on");
    $btnColorChip.removeAttr("title");
    $this.parent().addClass("on");
    $this.attr("title", "selected");

    //이미지변경
    $(".prd-thumb-wrap .nav-item").eq(1).find("img").attr("src",img1).attr("alt",imgAlt1);
    $(".prd-thumb-wrap .sul-slide-item").eq(1).find("img").attr("src",img1).attr("alt",imgAlt1);
    $(".prd-thumb-wrap .nav-item").eq(2).find("img").attr("src",img2).attr("alt",imgAlt2);
    $(".prd-thumb-wrap .sul-slide-item").eq(2).find("img").attr("src",img2).attr("alt",imgAlt2);

    $('.prd-price-wrap .prd-color').find('.measure-item').text(colorName);
});

// 컬러칩 Init
var colorChipLength = $('.color-chip-list').children('li').length;
var firstColorName = $('.color-chip-list').find('li:first').children('a').data('color-name');
if (colorChipLength > 0) {
    $('.color-chip-list').find('li:first').addClass('on').children('a').attr("title", "selected");
    $('.prd-measure.prd-color').find('.measure-item').text(firstColorName);
} else {
    $('.prd-info-wrap').find(".prd-price-wrap").addClass('color-chip-none');
}

//리뷰
$('.customer-review-item').on('click','.comment-wrap',function(){
    $(this).addClass('open');
});


$('.photo-list').slick({
    slidesToShow: 4.277777,
    arrows: false,
    infinite:false,
    focusOnSelect:true,
    centerMode: false,
    variableWidth: true,
    draggable : true,
    swipeToSlide : true,
    responsive: [{
        breakpoint: 900,
        settings: {
            slidesToShow: 2.12
        }
    },{
        breakpoint: 341,
        settings: {
            slidesToShow: 1.12
        }
    }
    ]
});

//상단 리뷰 버튼
$('.review-count').on('click','a',function(e){
    e.preventDefault();
    $('html, body').stop().animate({
        scrollTop: $('#accordion5').offset().top
    }, 0);
});

//SNS 공유 버튼
$(document).ready(function() {
    var h, e, f;
	var g = $('.prd-name-ko').html();
    $("#sns-facebook").unbind("click").click(function(a) {
        trackClicksEx("facebook", true);
        h = "http://www.facebook.com/sharer.php?u=" + encodeURIComponent(location.href) + "&t=" + encodeURIComponent(g) + "";
        e = 600;
        f = 600;
        window.open(h, "share", "width=" + e + ", height=" + f + ", scrollbars=yes")
    });
    $("#sns-twitter").unbind("click").click(function(a) {
        trackClicksEx("twitter", true);
        h = "http://twitter.com/share?text=" + encodeURIComponent(g) + "&url=" + encodeURIComponent(location.href) + "";
        e = 600;
        f = 400;
        window.open(h, "share", "width=" + e + ", height=" + f + ", scrollbars=yes")
    })
});

function trackClicksEx(){
    return false;
}